import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, Inject, OnInit, OnDestroy } from "@angular/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MAT_DIALOG_DATA,MatDialogRef, MatDialog, MatDialogTitle,MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { UploadVaccinationComponent } from '../banner-notification/upload-vaccination/upload-vaccination.component';

@Component({
  selector: "app-vaccinationreminder",
  templateUrl: "./vaccinationreminder.component.html",
  styleUrls: ["./vaccinationreminder.component.scss"],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButton,
  ],
})
export class VaccinationreminderComponent implements OnInit, OnDestroy {
  vaccinationDue: any;
  vaccinationMessage: string;
  logoImage = "./../../assets/images/bddc-bouncer-logo.png";
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>,
    private overlayContainer: OverlayContainer,
    public breakpointObserver: BreakpointObserver,
    private dialog: MatDialog
  ) {
    overlayContainer
      .getContainerElement()
      .classList.add("vaccination-reminder-dialog-overlay");
    overlayContainer
      .getContainerElement()
      .classList.remove("mini-calendar-dialog_overlay");
  }

  ngOnInit(): void {
    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result.matches) {
          this.setMobileLayout();
        } else {
          this.setDesktopLayout();
        }
      });
    this.vaccinationDue = this.data.vaccinationDue;
    this.vaccinationMessage = this.data.message;
  }

  onUpdate(): void {
    this.dialog.open(UploadVaccinationComponent, {});
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.overlayContainer
      .getContainerElement()
      .classList.remove("vaccination-reminder-dialog-overlay");
  }

  setMobileLayout() {
    if (window.innerWidth > 830 && window.innerWidth < 1360) {
      this.dialogRef.updateSize("500px", "475px");
    } else {
      this.dialogRef.updateSize("343px", "375px");
    }
  }

  setDesktopLayout() {
    this.dialogRef.updateSize("600px", "600px");
  }
}